import groupModule from '../groupModule';

function groupStoreItem(groupResources) {
    "ngInject";
    return {
        restrict: "A",
        templateUrl: groupResources.templates.groupStoreItemTemplate
    }
};

groupModule.directive("groupStoreItem", groupStoreItem);

export default groupStoreItem;